import { createSlice } from '@reduxjs/toolkit'

const {
    actions: {
        getApkStart,
        getApkSuccess,
        getApkFailure,

        addApkStart,
        addApkSuccess,
        addApkFailure
    },
    reducer
} = createSlice({
    name: 'uploadApk',
    initialState: {
        isLoadingGetApk: false,
        apkListing: {},
        isApkError: null,
        isAddApkLoading: false,
        isAddApkData: false,
        isAddApkError: null
    },
    reducers: {
        getApkStart: (state) => ({
            ...state,
            isLoadingGetApk: true,
            isApkError: null
        }),
        getApkSuccess: (state, { payload }) => ({
            ...state,
            isLoadingGetApk: false,
            apkListing: payload,
            isApkError: null
        }),
        getApkFailure: (state, { payload }) => ({
            ...state,
            isLoadingGetApk: false,
            isApkError: payload

        }),

        addApkStart: (state) => ({
            ...state,
            isAddApkLoading: true,
            isAddApkError: null
        }),
        addApkSuccess: (state, { payload }) => ({
            ...state,
            isAddApkLoading: false,
            isAddApkData: payload
        }),
        addApkFailure: (state, { payload }) => ({
            ...state,
            isAddApkLoading: false,
            isAddApkError: payload
        })
    }
})

export default reducer
export {
    getApkStart,
    getApkSuccess,
    getApkFailure,

    addApkStart,
    addApkSuccess,
    addApkFailure
}
